/* global axios */
import ApiClient from '../ApiClient';

class BrainFaqAPI extends ApiClient {
  constructor() {
    super('brain/faqs', { accountScoped: true });
  }

  get({ page = 1, search, assistantId, status } = {}) {
    return axios.get(this.url, {
      params: { page, search, assistant_id: assistantId, status },
    });
  }

  // Override to wrap body in { faq: } and pass assistant_id as query param
  create(data) {
    const { assistantId, ...faqData } = data;
    return axios.post(
      this.url,
      { faq: faqData },
      { params: { assistant_id: assistantId } }
    );
  }

  // storeFactory calls update(id, updateObj) with 2 args (id separate from data)
  update(id, updateObj = {}) {
    const { assistantId, ...faqData } = updateObj;
    return axios.patch(
      `${this.url}/${id}`,
      { faq: faqData },
      { params: { assistant_id: assistantId } }
    );
  }

  delete(payload) {
    const { id, assistantId } =
      typeof payload === 'object' ? payload : { id: payload };
    return axios.delete(`${this.url}/${id}`, {
      params: { assistant_id: assistantId },
    });
  }

  approve({ id, assistantId }) {
    return axios.patch(
      `${this.url}/${id}/approve`,
      {},
      { params: { assistant_id: assistantId } }
    );
  }

  reject({ id, assistantId }) {
    return axios.patch(
      `${this.url}/${id}/reject`,
      {},
      { params: { assistant_id: assistantId } }
    );
  }

  bulkActions({ ids, action, assistantId }) {
    return axios.post(
      `${this.url}/bulk_actions`,
      { ids, action },
      { params: { assistant_id: assistantId } }
    );
  }
}

export default new BrainFaqAPI();
